import { EventContentArg } from '@fullcalendar/core';

/**
 * 이벤트 타입 구분 인터페이스
 */
interface EventTypeChecker {
  isSubscribedEvent: (eventInfo: EventContentArg) => boolean;
  isBookingEvent: (eventInfo: EventContentArg) => boolean;
}

/**
 * 이벤트 타입 체커
 * - SRP: 이벤트 타입 구분만 담당
 */
export const eventTypeChecker: EventTypeChecker = {
  isSubscribedEvent: (eventInfo) => {
    return eventInfo.event.extendedProps?.isSubscribed === true;
  },
  isBookingEvent: (eventInfo) => {
    return !eventInfo.event.extendedProps?.isSubscribed;
  },
};
